import { TreeRecord } from '../types';

export const getRootAndChildNodes = <
    RecordType extends TreeRecord = TreeRecord
>(
    nodes: RecordType[]
) => {
    const rootNodes: RecordType[] = [];
    const childNodes: RecordType[] = [];

    const nodesAreChildren: { [key: string]: boolean } = {};
    nodes.forEach(node => {
        (node.children || []).forEach(child => {
            nodesAreChildren[child] = true;
        });
        if (!nodesAreChildren[node.id]) {
            nodesAreChildren[node.id] = false;
        }
    });

    nodes.forEach(node => {
        if (nodesAreChildren[node.id]) {
            childNodes.push(node);
        } else {
            rootNodes.push(node);
        }
    });

    return { rootNodes, childNodes };
};
